import api from '../api.js';
import { notify } from '../../versa/msgbox.js';
import * as types from '../types.js';

function lockoutExpirationIso() {
	const d = new Date();
	d.setDate(d.getDate() + 30);
	return d.toISOString();
}

const WEEKDAYS = [
	{ key: 'mon', label: 'Seg' },
	{ key: 'tue', label: 'Ter' },
	{ key: 'wed', label: 'Qua' },
	{ key: 'thu', label: 'Qui' },
	{ key: 'fri', label: 'Sex' },
	{ key: 'sat', label: 'Sáb' },
	{ key: 'sun', label: 'Dom' },
];

function timeOptionsHtml(selected) {
	const parts = [];
	for (let h = 0; h < 24; h += 1) {
		for (const m of [0, 30]) {
			const v = `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
			parts.push(`<option value="${v}"${v === selected ? ' selected' : ''}>${v}</option>`);
		}
	}
	return parts.join('');
}

function scheduleRowsHtml() {
	return WEEKDAYS.map(({ key, label }) => `
		<div class="uac-day" data-day="${key}">
			<label class="uac-day-check">
				<input type="checkbox" class="uac-enabled" data-day="${key}">
				<span>${label}</span>
			</label>
			<select class="uac-start" data-day="${key}" disabled>${timeOptionsHtml('08:00')}</select>
			<span class="uac-until">até</span>
			<select class="uac-end" data-day="${key}" disabled>${timeOptionsHtml('18:00')}</select>
		</div>
	`).join('');
}

function eventLabel(type) {
	return ({
		login: 'Login',
		logout: 'Logout',
		login_denied: 'Login negado',
		session_end: 'Fim de sessão',
		activated: 'Ativação',
		deactivated: 'Inativação',
		blocked: 'Bloqueio',
		unblocked: 'Desbloqueio',
		group_added: 'Grupo adicionado',
		group_removed: 'Grupo removido',
	})[type] || type || '';
}

function formatDuration(sec) {
	if (sec == null || sec === '') return '';
	const s = Number(sec);
	if (!Number.isFinite(s) || s < 0) return '';
	const h = Math.floor(s / 3600);
	const m = Math.floor((s % 3600) / 60);
	if (h > 0) return `Duração ${h}h ${String(m).padStart(2, '0')}m`;
	return `Duração ${m}m`;
}

function formatWhen(iso) {
	if (!iso) return '';
	const d = new Date(iso);
	if (Number.isNaN(d.getTime())) return String(iso);
	const pad = (n) => String(n).padStart(2, '0');
	return `${pad(d.getDate())}-${pad(d.getMonth() + 1)}-${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
}

function eventDetail(row) {
	const parts = [];
	const detail = (row?.detail || '').trim();
	if (detail) parts.push(detail);
	const dur = formatDuration(row?.duration_seconds);
	if (dur) parts.push(dur);
	const origin = (row?.origin || '').trim();
	if (origin && ['login', 'logout', 'login_denied', 'session_end'].includes(row?.event_type)) {
		parts.push(`Origem: ${origin}`);
	}
	return parts.join(' | ');
}

function escapeHtml(value) {
	return String(value ?? '')
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;');
}

export default {

	html: `
		<style>
			#user .form-tabs { display: flex; flex-wrap: wrap; align-items: center; gap: 0.35rem 0.5rem; padding: 0 0 0 0.5rem; background: #f1f5f9; border-radius: 8px 8px 0 0; margin: 0 0 0.75rem 0; }
			#user .form-tab { padding: 0.65rem 1.1rem; cursor: pointer; font-weight: 600; font-size: 0.88rem; color: #64748b; background: transparent; border: none; border-radius: 6px; }
			#user .form-tab:hover { color: #334155; background: #e2e8f0; }
			#user .form-tab.active { color: #4f46e5; background: white; box-shadow: 0 -1px 3px rgba(0,0,0,0.06); }
			#user .form-tab-panel { display: none; }
			#user .form-tab-panel.active { display: block; }
			#user #id { width: 20rem; }
			#user #name { width: 20rem; }
			#user #email { width: 20rem; }
			#user #phone { width: 10rem; }
			#user #username { width: 10rem; }
			#user #user_status { width: 10rem; }
			#user #manager_user_id { width: 22rem; }
			#user #access_override_until { width: 14rem; }
			#user .uac-master { display: flex; align-items: center; gap: 0.5rem; margin: 0.5rem 0 1rem; font-weight: 600; }
			#user .uac-schedule { display: flex; flex-direction: column; gap: 0.35rem; max-width: 36rem; }
			#user .uac-day { display: grid; grid-template-columns: 5.5rem 7rem auto 7rem; gap: 0.4rem; align-items: center; }
			#user .uac-day-check { display: flex; align-items: center; gap: 0.35rem; margin: 0; }
			#user .uac-until { color: #64748b; font-size: 0.85rem; }
			#user .uac-actions { margin: 0.6rem 0 1rem; display: flex; flex-wrap: wrap; gap: 0.5rem; }
			#user .uac-hint { font-size: 0.82rem; color: #64748b; margin: 0 0 0.75rem; }
			#user .uac-section { border-top: 1px solid #e2e8f0; margin-top: 1rem; padding-top: 0.75rem; }
			#user .uac-section h4 { margin: 0 0 0.5rem; font-size: 0.9rem; }
			#user .uac-log-filters { display: flex; flex-wrap: wrap; gap: 0.5rem; align-items: end; margin-bottom: 0.5rem; }
			#user .uac-log-filters label { margin: 0; }
			#user .uac-log-table-wrap { max-height: 18rem; overflow: auto; border: 1px solid #e2e8f0; border-radius: 6px; }
			#user .uac-log-table { width: 100%; border-collapse: collapse; font-size: 0.82rem; }
			#user .uac-log-table th, #user .uac-log-table td { border-bottom: 1px solid #f1f5f9; padding: 0.3rem 0.45rem; text-align: left; vertical-align: top; }
			#user .uac-log-table th { background: #f8fafc; position: sticky; top: 0; }
			#user .uac-log-table td.uac-log-detail { max-width: 22rem; word-break: break-word; }
			#user .uac-he-row { display: flex; flex-wrap: wrap; gap: 0.5rem; align-items: end; margin-bottom: 0.5rem; }
			#user .uac-disabled { opacity: 0.45; pointer-events: none; }
		</style>
		<form id="user" class="form" autocomplete="off">
			<div class="form-tabs">
				<button type="button" class="form-tab active" data-tab="dados">Dados</button>
				<button type="button" class="form-tab" data-tab="acesso">Controle de acesso</button>
				<button type="button" class="form-tab" data-tab="log">LOG</button>
			</div>
			<div class="form-tab-panels">
			<div id="tab-dados" class="form-tab-panel active">
			<div class="fsb">
				<label title="Status do usuário no sistema">Status
					<input id="user_status" type="text" disabled>
				</label>
			</div>
			<div class="fsb">
				<label title="Identificador do usuário">Usuário
					<input id="id" type="text" disabled>
				</label>
				<label title="Usuário de acesso ao sistema">Username<sup>*</sup>
					<input id="username" type="text" required>
				</label>
				<label title="Telefone com DDI e DDD">Telefone
					<input id="phone" type="text" placeholder="+00 (00) 0000-0000">
				</label>
			</div>
			<div class="fsb">
				<label title="Nome do usuário">Nome<sup>*</sup>
					<input id="name" type="text" required>
				</label>
				<label title="Email">Email
					<input id="email" type="text">
				</label>
			</div>
			<div class="fsb">
				<label class="keymap">Grupos<sup>*</sup>
					<select id="groups" multiple size="4" required>
					</select>
				</label>
				<span class="keymap">
					<button class="bn_Left" title="Incluir grupos selecionados à direita"> &#x1F844;</button>
					<button class="bn_Right" title="Remover grupos selecionados à esquerda">&#x1F846;</button>
				</span>
				<label class="keymap">Disponíveis
					<select id="available" multiple size="4">
					</select>
				</label>
			</div>
			</div>

			<div id="tab-acesso" class="form-tab-panel">
				<label class="uac-master">
					<input id="access_control_enabled" type="checkbox">
					Ligar controle de acesso
				</label>
				<p class="uac-hint">Fuso: America/Sao_Paulo. Dia desmarcado = sem acesso. Horários de 30 em 30 minutos.</p>
				<div id="uac_body">
					<div class="uac-schedule">
						${scheduleRowsHtml()}
					</div>
					<div class="uac-actions">
						<button type="button" class="button bn_uac_copy_mon">Copiar Seg → dias úteis</button>
					</div>
					<div class="fsb">
						<label title="Gestor responsável pela aprovação de horas extras">Responsável (gestor)
							<input id="manager_user_id" type="text" list="users_managers" placeholder="Selecione o gestor">
						</label>
						<label title="Usuário destinado ao Coletor">
							<input id="collector_only" type="checkbox"> Somente Coletor
						</label>
					</div>
					<div class="fsb">
						<label title="Liberação pontual até data/hora (ISO local)">Liberação até
							<input id="access_override_until" type="datetime-local">
						</label>
					</div>
					<datalist id="users_managers"></datalist>

					<div class="uac-section">
						<h4>Horas extras</h4>
						<div class="uac-he-row">
							<label>De
								<input id="he_from" type="datetime-local">
							</label>
							<label>Até
								<input id="he_to" type="datetime-local">
							</label>
							<label>Motivo
								<input id="he_reason" type="text" style="width:14rem">
							</label>
							<button type="button" class="button bn_he_create">Solicitar HE</button>
						</div>
						<div class="uac-log-table-wrap">
							<table class="uac-log-table">
								<thead>
									<tr><th>Período</th><th>Status</th><th>Motivo</th><th></th></tr>
								</thead>
								<tbody id="he_tbody"></tbody>
							</table>
						</div>
					</div>
				</div>
			</div>

			<div id="tab-log" class="form-tab-panel">
				<p class="uac-hint">Auditoria de login, logout, grupos, ativação/inativação e bloqueio/desbloqueio. Histórico admin só a partir da publicação desta versão.</p>
				<div class="uac-log-filters">
					<label>De
						<input id="sess_from" type="date">
					</label>
					<label>Até
						<input id="sess_to" type="date">
					</label>
					<button type="button" class="button bn_sess_search">Buscar</button>
					<button type="button" class="button bn_sess_csv">Exportar CSV</button>
					<button type="button" class="button bn_sess_xlsx">Exportar Excel</button>
				</div>
				<div class="uac-log-table-wrap">
					<table class="uac-log-table">
						<thead>
							<tr>
								<th>Data/hora</th>
								<th>Evento</th>
								<th>Usuário</th>
								<th>IP</th>
								<th>Detalhe</th>
							</tr>
						</thead>
						<tbody id="sess_tbody"></tbody>
					</table>
				</div>
			</div>
			</div>

			<div class="fsb mtm">
				<span>
					<button type="button" class="button bn_user_disable" title="Impede login até reativar">Inativar</button>
					<button type="button" class="button bn_user_enable" title="Permite login novamente">Ativar</button>
					<button type="button" class="button bn_user_block" title="Bloqueia login temporariamente">Bloquear</button>
					<button type="button" class="button bn_user_unblock" title="Remove bloqueio">Desbloquear</button>
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,

	form:
	{
		selector: '#user',
		init(formset) {
			const root = () => formset.dialog?.getNode?.();
			const formEl = () => root()?.querySelector?.('#user');
			const getId = () => formEl()?.querySelector?.('#id')?.value;
			const setStatus = (s) => { const el = formEl()?.querySelector?.('#user_status'); if (el) el.value = s; };
			const doAction = async (payload, statusLabel) => {
				const id = getId();
				if (!id) return;
				const resp = await api.call(api.update_user, id, payload);
				if (resp != null) {
					setStatus(statusLabel);
					loadSessionLog();
				} else notify('Falha ao atualizar usuário.', 'Usuários');
			};

			const syncAccessEnabled = () => {
				const form = formEl();
				if (!form) return;
				const on = !!form.querySelector('#access_control_enabled')?.checked;
				const body = form.querySelector('#uac_body');
				if (body) body.classList.toggle('uac-disabled', !on);
				form.querySelectorAll('.uac-day').forEach((row) => {
					const en = row.querySelector('.uac-enabled');
					const start = row.querySelector('.uac-start');
					const end = row.querySelector('.uac-end');
					const dayOn = on && !!en?.checked;
					if (start) start.disabled = !dayOn;
					if (end) end.disabled = !dayOn;
					if (en) en.disabled = !on;
				});
			};

			const dialogNode = root();
			if (dialogNode) {
				dialogNode.addEventListener('click', (ev) => {
					const tab = ev.target?.closest?.('.form-tab');
					if (tab && formEl()?.contains(tab)) {
						ev.preventDefault();
						const id = tab.getAttribute('data-tab');
						formEl().querySelectorAll('.form-tab').forEach((t) => t.classList.remove('active'));
						formEl().querySelectorAll('.form-tab-panel').forEach((p) => p.classList.remove('active'));
						tab.classList.add('active');
						formEl().querySelector(`#tab-${id}`)?.classList.add('active');
						if (id === 'log') loadSessionLog();
						return;
					}
					const t = ev.target?.closest?.('.bn_user_disable');
					if (t) { ev.preventDefault(); ev.stopPropagation(); doAction({ is_disabled: true }, 'Inativo'); return; }
					const e = ev.target?.closest?.('.bn_user_enable');
					if (e) { ev.preventDefault(); ev.stopPropagation(); doAction({ is_disabled: false }, 'Ativo'); return; }
					const b = ev.target?.closest?.('.bn_user_block');
					if (b) { ev.preventDefault(); ev.stopPropagation(); doAction({ lockout_expiration: lockoutExpirationIso() }, 'Bloqueado'); return; }
					const u = ev.target?.closest?.('.bn_user_unblock');
					if (u) { ev.preventDefault(); ev.stopPropagation(); doAction({ lockout_expiration: null }, 'Ativo'); return; }
					const copy = ev.target?.closest?.('.bn_uac_copy_mon');
					if (copy) {
						ev.preventDefault();
						const form = formEl();
						const mon = form?.querySelector('.uac-day[data-day="mon"]');
						if (!mon) return;
						const en = mon.querySelector('.uac-enabled')?.checked;
						const st = mon.querySelector('.uac-start')?.value;
						const ed = mon.querySelector('.uac-end')?.value;
						['tue', 'wed', 'thu', 'fri'].forEach((day) => {
							const row = form.querySelector(`.uac-day[data-day="${day}"]`);
							if (!row) return;
							const c = row.querySelector('.uac-enabled');
							if (c) c.checked = !!en;
							const s = row.querySelector('.uac-start');
							const e2 = row.querySelector('.uac-end');
							if (s && st) s.value = st;
							if (e2 && ed) e2.value = ed;
						});
						syncAccessEnabled();
						return;
					}
					const search = ev.target?.closest?.('.bn_sess_search');
					if (search) { ev.preventDefault(); loadSessionLog(); return; }
					const csv = ev.target?.closest?.('.bn_sess_csv');
					if (csv) { ev.preventDefault(); exportSession('csv'); return; }
					const xlsx = ev.target?.closest?.('.bn_sess_xlsx');
					if (xlsx) { ev.preventDefault(); exportSession('xlsx'); return; }
					const he = ev.target?.closest?.('.bn_he_create');
					if (he) { ev.preventDefault(); createHe(); return; }
					const appr = ev.target?.closest?.('.bn_he_approve');
					if (appr) { ev.preventDefault(); decideHe(appr.getAttribute('data-id'), 'approved'); return; }
					const rej = ev.target?.closest?.('.bn_he_reject');
					if (rej) { ev.preventDefault(); decideHe(rej.getAttribute('data-id'), 'rejected'); return; }
				});
				dialogNode.addEventListener('change', (ev) => {
					if (ev.target?.id === 'access_control_enabled' || ev.target?.classList?.contains('uac-enabled')) {
						syncAccessEnabled();
					}
				});
			}

			const loadManagers = async () => {
				const form = formEl();
				const dl = form?.querySelector('#users_managers');
				if (!dl) return;
				try {
					const data = await api.call(api.list_users, '');
					const list = Array.isArray(data) ? data : [];
					dl.innerHTML = list.map((u) =>
						`<option value="${u.id}">${(u.name || u.username || u.id)}</option>`
					).join('');
				} catch (_) { /* ignore */ }
			};

			const loadSessionLog = async () => {
				const id = getId();
				const form = formEl();
				const tbody = form?.querySelector('#sess_tbody');
				if (!id || !tbody) return;
				const from = form.querySelector('#sess_from')?.value;
				const to = form.querySelector('#sess_to')?.value;
				let q = '?limit=500';
				if (from) q += `&from=${encodeURIComponent(from + 'T00:00:00')}`;
				if (to) q += `&to=${encodeURIComponent(to + 'T23:59:59')}`;
				const data = await api.call(api.list_user_session_events, id, q);
				const items = data?.items || [];
				tbody.innerHTML = items.length
					? items.map((r) => {
						const who = r.actor_label || r.actor_username || r.subject_username || '';
						return `<tr>
						<td>${escapeHtml(formatWhen(r.occurred_at))}</td>
						<td>${escapeHtml(eventLabel(r.event_type))}</td>
						<td>${escapeHtml(who)}</td>
						<td>${escapeHtml(r.ip || '')}</td>
						<td class="uac-log-detail">${escapeHtml(eventDetail(r))}</td>
					</tr>`;
					}).join('')
					: '<tr><td colspan="5">Sem eventos no período.</td></tr>';
			};

			const exportSession = async (format) => {
				const id = getId();
				const form = formEl();
				if (!id) return notify('Salve o usuário antes de exportar.', 'Usuários');
				const from = form.querySelector('#sess_from')?.value;
				const to = form.querySelector('#sess_to')?.value;
				let q = `?format=${encodeURIComponent(format)}`;
				if (from) q += `&from=${encodeURIComponent(from + 'T00:00:00')}`;
				if (to) q += `&to=${encodeURIComponent(to + 'T23:59:59')}`;
				try {
					const resp = await api.export_user_session_events(id, q);
					if (!resp || !resp.ok) {
					notify('Falha ao exportar o LOG.', 'Usuários');
					return;
				}
				const blob = await resp.blob();
				const cd = resp.headers.get('Content-Disposition') || '';
				const m = cd.match(/filename="?([^"]+)"?/i);
				const filename = m?.[1] || `log-usuario.${format === 'xlsx' ? 'xlsx' : 'csv'}`;
					const url = URL.createObjectURL(blob);
					const a = document.createElement('a');
					a.href = url;
					a.download = filename;
					a.click();
					URL.revokeObjectURL(url);
				} catch (err) {
					notify(err?.message || 'Falha ao exportar.', 'Usuários');
				}
			};

			const loadHe = async () => {
				const id = getId();
				const tbody = formEl()?.querySelector('#he_tbody');
				if (!id || !tbody) return;
				const data = await api.call(api.list_user_overtime_requests, `?user_id=${encodeURIComponent(id)}&limit=50`);
				const items = Array.isArray(data) ? data : [];
				tbody.innerHTML = items.length
					? items.map((r) => {
						const period = `${formatWhen(r.from_at)} → ${formatWhen(r.to_at)}`;
						const actions = r.status === 'pending'
							? `<button type="button" class="button bn_he_approve" data-id="${r.id}">Aprovar</button>
							   <button type="button" class="button bn_he_reject" data-id="${r.id}">Rejeitar</button>`
							: '';
						return `<tr>
							<td>${period}</td>
							<td>${r.status || ''}</td>
							<td>${r.reason || ''}</td>
							<td>${actions}</td>
						</tr>`;
					}).join('')
					: '<tr><td colspan="4">Nenhuma solicitação.</td></tr>';
			};

			const createHe = async () => {
				const id = getId();
				const form = formEl();
				if (!id) return notify('Salve o usuário antes de solicitar HE.', 'Usuários');
				const from = form.querySelector('#he_from')?.value;
				const to = form.querySelector('#he_to')?.value;
				const reason = form.querySelector('#he_reason')?.value;
				if (!from || !to) return notify('Informe início e fim da HE.', 'Usuários');
				const managerRaw = form.querySelector('#manager_user_id')?.value;
				const resp = await api.call(api.create_user_overtime_request, {
					user_id: id,
					from_at: new Date(from).toISOString(),
					to_at: new Date(to).toISOString(),
					reason,
					manager_user_id: managerRaw || null,
				});
				if (resp == null) notify('Falha ao criar solicitação.', 'Usuários');
				else {
					notify('Solicitação de HE criada.', 'Usuários');
					loadHe();
				}
			};

			const decideHe = async (requestId, status) => {
				if (!requestId) return;
				const resp = await api.call(api.decide_user_overtime_request, requestId, { status });
				if (resp == null) notify('Falha ao decidir HE.', 'Usuários');
				else {
					notify(status === 'approved' ? 'HE aprovada.' : 'HE rejeitada.', 'Usuários');
					loadHe();
				}
			};

			formset._uac = {
				syncAccessEnabled,
				loadSessionLog,
				loadHe,
				loadManagers,
				applySchedule(schedule) {
					const form = formEl();
					if (!form || !schedule) return;
					WEEKDAYS.forEach(({ key }) => {
						const day = schedule[key] || {};
						const row = form.querySelector(`.uac-day[data-day="${key}"]`);
						if (!row) return;
						const en = row.querySelector('.uac-enabled');
						const st = row.querySelector('.uac-start');
						const ed = row.querySelector('.uac-end');
						if (en) en.checked = !!day.enabled;
						if (st && day.start) st.value = day.start;
						if (ed && day.end) ed.value = day.end;
					});
					syncAccessEnabled();
				},
				readSchedule() {
					const form = formEl();
					const out = {};
					WEEKDAYS.forEach(({ key }) => {
						const row = form?.querySelector(`.uac-day[data-day="${key}"]`);
						out[key] = {
							enabled: !!row?.querySelector('.uac-enabled')?.checked,
							start: row?.querySelector('.uac-start')?.value || '08:00',
							end: row?.querySelector('.uac-end')?.value || '18:00',
						};
					});
					return out;
				},
				readAccessFields() {
					const form = formEl();
					const overrideLocal = form?.querySelector('#access_override_until')?.value;
					let access_override_until = null;
					if (overrideLocal) {
						access_override_until = new Date(overrideLocal).toISOString();
					}
					const managerRaw = (form?.querySelector('#manager_user_id')?.value || '').trim();
					return {
						access_control_enabled: !!form?.querySelector('#access_control_enabled')?.checked,
						work_timezone: 'America/Sao_Paulo',
						work_schedule: this.readSchedule(),
						manager_user_id: managerRaw || null,
						collector_only: !!form?.querySelector('#collector_only')?.checked,
						access_override_until,
					};
				},
				applyAccessFields(data) {
					const form = formEl();
					if (!form || !data) return;
					const ac = form.querySelector('#access_control_enabled');
					if (ac) ac.checked = !!data.access_control_enabled;
					const co = form.querySelector('#collector_only');
					if (co) co.checked = !!data.collector_only;
					const mgr = form.querySelector('#manager_user_id');
					if (mgr) mgr.value = data.manager_user_id || '';
					const ov = form.querySelector('#access_override_until');
					if (ov && data.access_override_until) {
						const d = new Date(data.access_override_until);
						if (!Number.isNaN(d.getTime())) {
							const pad = (n) => String(n).padStart(2, '0');
							ov.value = `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
						}
					} else if (ov) ov.value = '';
					this.applySchedule(data.work_schedule || {});
					syncAccessEnabled();
					if (data.id) {
						loadSessionLog();
						loadHe();
					}
				},
			};

			loadManagers();
			syncAccessEnabled();
			Object.getPrototypeOf(this).init?.call(this, formset);
		},
		afterEditSetValues(fs) {
			const data = fs?._uac_pending_data;
			if (data) fs._uac?.applyAccessFields?.(data);
			else fs._uac?.syncAccessEnabled?.();
		},
	},

	fields: [
		{ properties: { selector: '#user_status' }, types: [] },
		{ properties: { selector: '#id' }, types: [] },
		{ properties: { selector: '#name' }, types: [types.name()] },
		{ properties: { selector: '#email' }, types: [types.email()] },
		{ properties: { selector: '#phone' }, types: [types.phone()] },
		{ properties: { selector: '#username' }, types: [types.username()] },
		{ properties: { selector: '#groups' }, types: [types.keymap('groups', '#available'), types.km_fill()] },
	]

};
